import InfoIcon from "@mui/icons-material/Info"
import { IconButton, Popover } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledIconButton = styled(IconButton)({
  padding: "0"
})

export const StyledInfoIcon = styled(InfoIcon)(({ theme }: any) => ({
  color: theme.palette.secondary["600"],
  padding: 0
}))

export const StyledPopover = styled(Popover)(({ theme }) => ({
  pointerEvents: "none"
}))
